import { render, staticRenderFns } from "./AgentNovelListItem.vue?vue&type=template&id=610c51db&scoped=true"
import script from "./AgentNovelListItem.vue?vue&type=script&lang=ts"
export * from "./AgentNovelListItem.vue?vue&type=script&lang=ts"
import style0 from "./AgentNovelListItem.vue?vue&type=style&index=0&id=610c51db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c51db",
  null
  
)

export default component.exports